import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useState } from 'react';
import styles from './Input.module.scss';
const normalizeSize = (size) => {
    if (size == null)
        return undefined;
    return typeof size === 'number' ? `${size}px` : size;
};
export const Input = ({ value, onChange, label, placeholder = '', type = 'text', width = 240, height = 40, error = false, disabled = false, className, showIcon = false, iconWidth = 16, iconHeight = 16, onFocus, onBlur, onKeyDown, autoFocus, id: propId, name, min, max, step, }) => {
    const generatedId = useId();
    const inputId = propId || generatedId;
    const [isFocused, setIsFocused] = useState(false);
    const [internalError, setInternalError] = useState(error);
    useEffect(() => {
        setInternalError(error);
    }, [error]);
    const handleFocus = () => {
        setIsFocused(true);
        if (error && value)
            setInternalError(false);
        onFocus?.();
    };
    const handleBlur = () => {
        setIsFocused(false);
        if (error)
            setInternalError(true);
        onBlur?.();
    };
    const handleChange = (e) => {
        if (error && isFocused)
            setInternalError(false);
        onChange(e.target.value);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Escape')
            e.currentTarget.blur();
        onKeyDown?.(e);
    };
    const inputClasses = [
        styles.input,
        isFocused ? styles['input--focused'] : '',
        value ? styles['input--filled'] : '',
        disabled ? styles['input--disabled'] : '',
        internalError ? styles['input--error'] : '',
        showIcon ? styles['input--with-icon'] : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("div", { className: styles['input-wrapper'], style: { width: normalizeSize(width) }, children: [label && (_jsx("label", { htmlFor: inputId, className: styles.input__label, children: label })), _jsxs("div", { className: styles.input__container, children: [_jsx("input", { id: inputId, name: name, type: type, className: inputClasses, value: value, placeholder: placeholder, disabled: disabled, autoFocus: autoFocus, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, onKeyDown: handleKeyDown, min: min, max: max, step: step, style: { height: normalizeSize(height) }, "aria-invalid": internalError, "aria-disabled": disabled }), showIcon && (_jsx("div", { className: styles.input__icon, "aria-hidden": true, style: {
                            width: normalizeSize(iconWidth),
                            height: normalizeSize(iconHeight),
                        } }))] })] }));
};
